<template>
  <div>
    <div class="current-position">
      <img class="app-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="app-container">
          <div class="current-position-logotext" v-if="pageName=='考生管理'">Examinee</div>
          <div class="current-position-logotext" v-if="pageName=='成绩管理'">Performance</div>
          <div class="current-position-logotext" v-if="pageName=='证书管理'">Certificate</div>
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="justify-between">
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{pageName}}
          </div>
          <ksglApp :examId="examId" v-if="pageName=='考生管理'"/>
          <cjglApp :examId="examId" v-if="pageName=='成绩管理'"/>
          <zsglApp :examId="examId" v-if="pageName=='证书管理'"/>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import ksglApp from '@/components/ksgl/ksgl-app.vue'
import cjglApp from '@/components/ksgl/cjgl-app.vue'
import zsglApp from '@/components/ksgl/zsgl-app.vue'
export default {
  components:{
    ksglApp,
    cjglApp,
    zsglApp,
  },
  data(){
    return{
      pageName:this.$route.query.name,
      examId:this.$route.query.examId
    }
  },
  created(){},
  methods:{}
}
</script>
<style scoped lang="css" src="../assets/css/base.css" />
<style>
.table-body .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #8fc930 !important;
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__input.is-focus  .el-checkbox__inner{
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__inner:hover{
  border-color: #8fc930 !important;
}
.table-body .el-button--text {
  color: #8fc930 !important;
}
.table-body .el-button--text:hover {
  color: #72b701 !important;
}
</style>
